module.exports = __webpack_public_path__ + "img/Powered_by_StandApp.cfd74de5.svg";